import type { PagesConfig } from "~/domains/pageSchemas";
export const fluggastrechteAbgabePages = {
  abgabe: {
    stepId: "/abgabe/start",
  },
} satisfies PagesConfig;
